"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcnVoucherEntity = void 0;
const AcnVoucherDto_1 = require("./AcnVoucherDto");
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const INDEX_NOT_FOUND = -1;
class AcnVoucherEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, acnVoucher) {
        super();
        this._requiredFieldsSetStatus = {
            dealerId: false,
            cardholderId: false
        };
        this._dependencies = dependencies;
        if (acnVoucher === undefined) {
            this._dto = new AcnVoucherDto_1.AcnVoucherDto();
        }
        else if (acnVoucher instanceof AcnVoucherDto_1.AcnVoucherDto) {
            this._dto = new AcnVoucherDto_1.AcnVoucherDto(acnVoucher);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (acnVoucher instanceof AcnVoucherEntity) {
            this._dto = new AcnVoucherDto_1.AcnVoucherDto(acnVoucher._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new AcnVoucherDto_1.AcnVoucherDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getDealerId() {
        return this._dto.dealerId;
    }
    setDealerId(untrustedValue) {
        const minLength = 1;
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("dealerId");
        this._requiredFieldsSetStatus.dealerId = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("dealerId", "Dealer ID is required."));
        }
        else if (_untrustedValue.length < minLength) {
            this.addError(new ValidationError_1.ValidationError("dealerId", `Dealer ID is below the minimum length (${minLength} chr).`));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("dealerId", `Dealer ID has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.dealerId) {
            return;
        }
        this._dto.dealerId = _untrustedValue;
        this._setIsDirty(true);
    }
    getCardHolderId() {
        return this._dto.cardholderId;
    }
    setCardHolderId(untrustedValue) {
        const minLength = 1;
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("cardholderId");
        this._requiredFieldsSetStatus.cardholderId = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("cardholderId", "Cardholder ID is required."));
        }
        else if (_untrustedValue.length < minLength) {
            this.addError(new ValidationError_1.ValidationError("cardholderId", `Cardholder ID is below the minimum length (${minLength} chr).`));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("cardholderId", `Cardholder ID has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.cardholderId) {
            return;
        }
        this._dto.cardholderId = _untrustedValue;
        this._setIsDirty(true);
    }
    getFirstName() {
        return this._dto.firstName;
    }
    setFirstName(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("firstName");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("firstName", "First Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("firstName", `First Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.firstName) {
            return;
        }
        this._dto.firstName = _untrustedValue;
        this._setIsDirty(true);
    }
    getLastName() {
        return this._dto.lastName;
    }
    setLastName(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("lastName");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("lastName", "Last Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("lastName", `Last Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.lastName) {
            return;
        }
        this._dto.lastName = _untrustedValue;
        this._setIsDirty(true);
    }
    getEmail() {
        return this._dto.email;
    }
    setEmail(untrustedValue) {
        const maxLength = 100;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("email");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("email", "Email is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("email", `Email has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.email) {
            return;
        }
        this._dto.email = _untrustedValue;
        this._setIsDirty(true);
    }
    getPhone() {
        return this._dto.phone;
    }
    setPhone(untrustedValue) {
        const maxLength = 30;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("phone");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("phone", `Phone has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.phone) {
            return;
        }
        this._dto.phone = _untrustedValue;
        this._setIsDirty(true);
    }
    getCardCode() {
        return this._dto.cardCode;
    }
    setCardCode(untrustedValue) {
        const maxLength = 30;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("cardCode");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("cardCode", `Card code has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.cardCode) {
            return;
        }
        this._dto.cardCode = _untrustedValue;
        this._setIsDirty(true);
    }
    getExpirationDate() {
        return this._dto.expirationDate;
    }
    setExpirationDate(untrustedValue) {
        const maxLength = 30;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("expirationDate");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("expirationDate", `Expiration Date has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.expirationDate) {
            return;
        }
        this._dto.expirationDate = _untrustedValue;
        this._setIsDirty(true);
    }
    getVin() {
        return this._dto.vin;
    }
    setVin(untrustedValue) {
        const maxLength = 30;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("vin");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("vin", `VIN has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.vin) {
            return;
        }
        this._dto.vin = _untrustedValue;
        this._setIsDirty(true);
    }
    getStations() {
        return this._dto.stations;
    }
    setStations(untrustedValue) {
        if (untrustedValue === this._dto.stations) {
            return;
        }
        if (!this.isNew && untrustedValue === this._dto.stations) {
            return;
        }
        this.clearError("stations");
        this._dto.stations = untrustedValue;
        this._setIsDirty(true);
    }
    getActivityLog() {
        return this._dto.activityLog;
    }
    getHasBeenRedeemed() {
        return this._dto.hasBeenRedeemed;
    }
    setHasBeenRedeemed(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("hasBeenRedeemed", "Has Been Redeemed is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("hasBeenRedeemed", "Has Been Redeemed is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else if (typeof untrustedValue === "boolean") {
            _untrustedValue = untrustedValue;
        }
        else {
            throw new Error("Invalid type");
        }
        if (!this.isNew && _untrustedValue === this._dto.hasBeenRedeemed) {
            return;
        }
        this.clearError("hasBeenRedeemed");
        this._dto.hasBeenRedeemed = _untrustedValue;
        this._setIsDirty(true);
    }
    getIsDeleted() {
        return this._dto.isDeleted;
    }
    setIsDeleted(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("isDeleted", "Is Deleted is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("isDeleted", "Is Deleted is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else if (typeof untrustedValue === "boolean") {
            _untrustedValue = untrustedValue;
        }
        else {
            throw new Error("Invalid type");
        }
        if (!this.isNew && _untrustedValue === this._dto.isDeleted) {
            return;
        }
        this.clearError("isDeleted");
        this._dto.isDeleted = _untrustedValue;
        this._setIsDirty(true);
    }
    loadAsync(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.acnVoucherDatastore
                    .getAsync(id);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("ACN Voucher is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto.activityLog = [];
                    const now = new Date();
                    dto.activityLog.push({
                        "date": now.toISOString(),
                        "description": "Created"
                    });
                    dto = yield this._dependencies.acnVoucherDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.acnVoucherDatastore
                        .updateAsync(dto);
                }
                this._dto.id = dto.id;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Voucher cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.acnVoucherDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.AcnVoucherEntity = AcnVoucherEntity;
//# sourceMappingURL=AcnVoucherEntity.js.map